export default "__VITE_ASSET__5TMs1JkT__"